import styled from "styled-components";
import { motion } from "framer-motion";
import Typography from "@/foundation/Typography/V2";

export const AccordionWrapper = styled.div`
  display: flex;
  // padding: 8px 8px 0px 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  //   background: var(--gray-25, #fcfcfd);
`;

export const AccordionHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  justify-content: space-between;
  width: 100%;
`;

export const AccordionContent = styled(motion.div)`
  display: flex;
  padding: 0px 32px 0px 8px;
  gap: 16px;
`;

export const Title = styled(Typography)`
  color: #293056;
  font-family: var(--man);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  max-width: 85%;
`;
